import { IAlp } from "@imaginelearning/mps-api-service";
import {
  classMap,
  UxAvatar,
  UxAvatarEnum,
  UxAvatarPriorityEnum,
  UxAvatarStyleEnum,
  UxIcon,
  UxProgress,
  UxPriorityEnum
} from "@imaginelearning/mps-ux-component-library";
import defaultConfig from "config";
import React, { useContext } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import getCurrentLessonIcon from "../common/icons";
import { AlpContext } from "../my-assignments-container";
import "./my-assignment-tile.scss";
import utcDateHandler from "../common/date-convertor";
import { assignmentProgess } from "../course-map-components/utils";
import TypeBadge from "./typebadge";
import useTheme from "../../../hooks/usetheme";

interface SubjectProps {
  assignmentDetails: IAlp;
  subjectName: string;
}

function MyAssignmentsTile(props: SubjectProps) {
  const { assignmentDetails, subjectName } = props;
  const { title, dueDate, lessons, ilpID, contentType, assessments } = assignmentDetails.assignmentInfo;
  const UTCDueDateWithZ = utcDateHandler(dueDate);
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { setIlpId, setContentType } = useContext(AlpContext);
  const newAssignment = assignmentDetails.isNew;

  const handleOnClick = () => {
    setIlpId(ilpID);
    setContentType(contentType);
    navigate(`/assignments/${ilpID}`);
  };

  const mydate = new Date(UTCDueDateWithZ);
  const config = defaultConfig();
  const defaultAvatar: UxAvatarEnum = config.defaults.avatar;
  const selectedIcon =
    assignmentDetails.assignmentInfo.icon === ""
      ? defaultAvatar
      : (UxAvatarEnum as any)[assignmentDetails.assignmentInfo.icon?.toUpperCase()];
  const options: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" };
  const dueDateHandle =
    UTCDueDateWithZ?.split("T")[0] === "9999-12-31" ? "" : `DUE DATE: ${mydate.toLocaleDateString("en-us", options)}`;

  const assignmentTile: JSX.Element = (
    <Card
      className={classMap("myassignment_tile", String(theme).replace(/_/g, "-"))}
      onClick={() => {
        handleOnClick();
      }}
    >
      <Row className="myassignment_tile_row">
        <Col xs={2} className={`text-center myassignment_tile_subject_row myassignment_tile_${subjectName}`}>
          <span className="header-icon">
            <UxIcon
              icon={getCurrentLessonIcon(subjectName)}
              className="myassignment_tile_subject_icon"
              theme={theme}
            />{" "}
          </span>
          <div className="myassignment_tile_subject_row_sub">
            {subjectName === "SEL" ? "PURPOSE" : subjectName.toUpperCase()}
          </div>
        </Col>
        <Col xs={7} className="myassignment_tile_title_row">
          <Row className="myassignment_tile_heading1">
            <Col xs={10} data-testid="myassignment-tile-assignment-type-badge">
              <h3 className="heading-style-h5">
                <TypeBadge contentType={contentType} />
              </h3>
            </Col>
          </Row>
          <Row className="myassignment_tile_heading1">
            <Col xs={12}>
              <h4 className="myassignment_tile_ellipsis">{title}</h4>
              <div className="myassignment_tile_due_date myassignment_tile_ellipsis">
                {dueDateHandle}
                {newAssignment && (
                  <span className={`myassignment_tile_new_assignment${dueDateHandle !== "" ? "_padded" : ""}`}>
                    New!
                  </span>
                )}
              </div>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col xs={12}>
              <UxProgress
                variant={UxPriorityEnum.SUCCESS}
                value={assignmentProgess(contentType, props.assignmentDetails.lessonAttempts, lessons, assessments)}
                className="myassignment_tile_progress_bar"
              />
            </Col>
          </Row>
        </Col>
        <Col xs={3} className="text-center p-0">
          <div className="myassignment_tile_icon_block">
            {assignmentDetails.assignmentInfo.icon ? (
              <div className="myassignment_tile_avatars">
                <UxAvatar
                  avatar={selectedIcon as UxAvatarEnum}
                  avatarType={UxAvatarPriorityEnum.DEFAULT}
                  avatarStyle={UxAvatarStyleEnum.BODY}
                  className="d-flex myassignment_tile_avatar"
                  theme={theme}
                />
              </div>
            ) : (
              <div className="myassignment_tile_avatars" />
            )}
            <div>
              <Button
                onClick={handleOnClick}
                className="myassignment_tile_go_button"
                data-testid="myassignment-tile-go-button"
              >
                Start
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
  return <div className="tiles">{assignmentTile}</div>;
}
export default MyAssignmentsTile;
